// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

M = M || {};
M.Number = M.Number || {};

M.Number.intToWord = function(intVal) {
  var wordMap = {
    0: 'zero',
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine'
  };
  return wordMap[intVal];
};

/**
 * Formats a number X to two decimal places in the following format:
 *  - if X < 0, this returns ($X.00 less)
 *  - if X > 0, this returns ($X.00 more)
 *  - if X = 0, this returns $0.00
 *  - if X is undefined, this returns $0.00
 */
M.Number.prettyMoneyFormat = function(money) {
  if (!money) {
    return '($0.00)';
  }

  var mNumber = Number(money);
  if (isNaN(mNumber) || mNumber === 0) {
    return '($0.00)';
  }

  if (mNumber < 0) {
    return '($' + Math.abs(mNumber).toFixed(2) + ' less)';
  }

  return '($' + mNumber.toFixed(2) + ' more)';
};

/**
 * Formats a number X to two decimal places in the following format:
 *  - if X < 0, this returns -$X.00
 *  - if X > 0, this returns +$X.00
 *  - if X = 0, this returns $0.00
 *  - if X is undefined, this returns $0.00
 */
M.Number.moneyFormat = function(money) {
  if (!money) {
    return '$0.00';
  }

  var mNumber = Number(money);
  if (isNaN(mNumber) || mNumber === 0) {
    return '$0.00';
  }

  if (mNumber < 0) {
    return '-$' + Math.abs(mNumber).toFixed(2);
  }

  return '$' + mNumber.toFixed(2);
};